module.exports = __webpack_public_path__ + "img/icon_map_188_on_001.3447e215.png";